import React from "react";
import "./button.scss";
import { Link } from "gatsby";

const Button = ({
  children,
  className = "",
  onClick,
  primary = false,
  type = "button",
  href = "",
  disabled = false,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  primary?: boolean;
  type?: "button" | "submit" | "reset" | "link" | "a";
  href?: string;
  disabled?: boolean;
  [key: string]: any;
}) => {
  if (primary) {
    className = `button--primary ${className}`;
  }

  return (
    <>
      {type === "link" && (
        <Link to={href} className={`button ${className}`} {...props}>
          {children}
        </Link>
      )}
      {(type === "button" || type === "submit" || type == "reset") && (
        <button
          type={type}
          className={`button ${className}`}
          onClick={onClick}
          disabled={disabled}
          {...props}
        >
          {children}
        </button>
      )}
      {type === "a" && (
        <a
          className={`button ${className}`}
          onClick={onClick}
          href={href}
          {...props}
        >
          {children}
        </a>
      )}
    </>
  );
};

const Icon = ({ children }: { children: React.ReactNode }) => {
  return <i className="button__icon">{children}</i>;
};
Button.Icon = Icon;

const Content = ({ children }: { children: React.ReactNode }) => {
  return <span className="button__content">{children}</span>;
};
Button.Content = Content;

export default Button;
